import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { GigyaService } from './gigya.service';
import { responseGetAccountInfo } from 'src/app/types/gigya-type';
import { TutorService } from '../tutor/tutor.service';
import { CustomNgxSpinnerService } from '../spinner/custom-ngx-spinner.service';
import { ActivatedRoute, Router } from '@angular/router';

export type login = {
  logged:boolean,
  userLogged: any
}
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  loggedIn = new BehaviorSubject<login>({logged:false, userLogged:null});
  loggedIn$ = this.loggedIn.asObservable();

  screenLoad = new BehaviorSubject({nameScreen: ""});
  screenLoad$ = this.screenLoad.asObservable();

  constructor(
    private gigya:GigyaService,
    private tutor:TutorService,
    private router:   Router,
    public loading: CustomNgxSpinnerService,
    private activeRoute: ActivatedRoute,  
    private ngZone: NgZone,) { 
    }
  callbackGetAccount(resp:responseGetAccountInfo){
    this.ngZone.run(()=>{
      if(resp.errorCode ===0){
        this.loggedIn.next({logged:true, userLogged:resp});
      }else{
        this.loggedIn.next({logged:false, userLogged:{}});
      }
    });
  }

  checkSessionLogin(){
    this.gigya.getAccountInfo({callback:this.callbackGetAccount.bind(this)})
  }

  getListMinors(user:any){
     return this.tutor.getListOfMinorsManaged({
        uid: user.UID
      });
  }

  addListener(){
    fromEvent(document, 'panini:onLogin').subscribe((ev:any)=>{
      if(ev?.detail?.context?.userLogged){
        this.gigya.hideScreenSet("registrationLoginContainer");
        this.loading.loadingOn();
        this.loggedIn.next({logged:true, userLogged:ev?.detail?.context?.userLogged});
      }
        
    });
    fromEvent(document, 'panini:onLogout').subscribe((ev)=>{
      console.log("User loggedOut",ev);
      //this.loggedIn.next({logged:false, userLogged:{}});
      let lang = location?.pathname?.split("/")[1];
      this.activeRoute.queryParams.subscribe(params => {
        let qParams:any = {};
        if(params['UID'] &&  params['country']){
          qParams.UID= params['UID'];
          qParams.country = params['country'];
        }
        this.router.navigate([lang == "br"? "pt-br":lang, 'home'],
        { queryParams: qParams,   onSameUrlNavigation: 'reload'  },).then(()=>{ location.reload()});
      });
    });
  }
}
